<template>
  <div id="zt8669">
    <div :id="$store.state.iscn?'z1':'z1_en'">
      <div>{{$store.state.iscn?'ZT8669 桌面智能终端':'ZT8669 Desktop Smart Terminal'}}</div>
      <label v-for="item in m1data" :key="item.label">
        <img :src="item.img" />
        <h5>{{item.label}}</h5>
      </label>
      <!-- <img :src="require('@/assets/pic/zt8669/bg1icon.png')" /> -->
    </div>
    <div id="z2" v-if="$store.state.iscn">
      <label>ZT8669 是为普惠金融全新打造的智能服务终端，目前在惠农、富农、裕农等场景中实现线上线下有机融合，为金融科技赋能乡村振兴提供示范服务，为广大农村提供“智慧农村+”综合服务平台。</label>
    </div>
    <div id="z2_en" v-else>
      <img :src="require('@/assets/pic/zt8228/icon1.png')"/>
      <img :src="require('@/assets/pic/zt8228/icon2.png')"/>
      <img :src="require('@/assets/pic/zt8228/icon3.png')"/>
    </div>
    <div id="z3">
      <span v-if="$store.state.iscn">
        <div>随心所欲  全景融合</div>
        <label>集成人脸识别、刷卡、扫码、存折等全部支付方式</label>
      </span>
      <span v-else>
        <h5>Modular design <br/>& Flexible Customization</h5>
        <h5>GAS & Water& Electricity <br/>module extendable</h5>
      </span>
    </div>
    <div id="z4">
      <div>{{$store.state.iscn?'强芯制造  超凡视界':'Powerful CPU & Excellent visual'}}</div>
      <label>{{$store.state.iscn?'高性能八核强劲CPU，搭配大视野高清触摸屏，纵享丝滑':'High-performance octa-core CPU, large touch screen'}} </label>
    </div>
    <div :id="$store.state.iscn?'z5':'z5_en'">
      <div>{{$store.state.iscn?'尺寸多变  自由选择':'Variable size, Free choice'}}</div>
      <label>{{$store.state.iscn?'尺寸自由选择，想你所想':'Free choice of size'}}</label>
    </div>
    <div :id="$store.state.iscn?'z6':'z6_en'">
      <div>{{$store.state.iscn?'功能齐全  操作简单':'Complete functions and simple operation'}}</div>
    </div>
    <payscene :data="sdata"></payscene>
    <pdspecs :data="$store.state.iscn?spdata:spdata_en"></pdspecs>
  </div>
</template>

<script>
import payscene from '@/components/payscene'
import pdspecs from '@/components/pdspecs'
export default {
  name: '',
  components: {
    payscene,pdspecs
  },
  props: {
    data: Object
  },
  watch: {
    
  },
  data () {
    var _this = this
    return {
      m1data: [
        {img: require('@/assets/pic/zt8669/zw.png'), label: _this.$t('lang.govmwork')},
        {img: require('@/assets/pic/zt8669/yh.png'), label: _this.$t('lang.bank')},
        {img: require('@/assets/pic/zt8669/yl.png'), label: _this.$t('lang.medicare')},
        {img: require('@/assets/pic/zt8669/jt.png'), label: _this.$t('lang.traffic')}
      ],
      sdata: {
        data: [
          {
            pic: require('@/assets/pic/zt8669/s1.png'),
            label: _this.$store.state.iscn?'助农点':'Convenience Store'
          },
          {
            pic: require('@/assets/pic/zt8669/s2.png'),
            label: _this.$store.state.iscn?'商超':'Supermarket'
          },
          {
            pic: require('@/assets/pic/zt8669/s3.png'),
            label: _this.$store.state.iscn?'银行网点':'Bank'
          },
        ]
      },
      spdata: {
        file: 'ZT8669',
        data: [
          {label: '处理器', desc: ['ARM八核2.0GHz高速处理器','4核Cortex-A73+ 4核Cortex-A53'],pic: 'cpu.png'},
          {label: '存储器', desc: ['4GB RAM +64GB ROM','最大支持8GB RAM +256GB ROM'],pic: 'ram.png'},
          {label: '操作系统', desc: ['Android 9.0','证通安全操作系统（ZOS）'], pic: 'sys.png'},
          {label: '显示屏', desc: ['11.6英寸1920×1080 LCD，背光可调','支持多点触控电容式触摸屏'], pic: 'disp.png'},
          {label: '环境摄像头', desc: ['130万像素','前分辨率1280×720', '最大帧数 30帧/秒'], pic: 'face.png'},
          {label: '人脸识别', desc: ['支持自动红外补光，自动对焦', '支持活体检测','支持人脸支付，支持选配3D结构光'], pic: 'face1.png'},
          {label: '移动网络', desc: ['支持 GSM / WCDMA / EVDO / TDD-LTE / FDD-LTE'], pic: 'mobi.png'},
          {label: 'WIFI', desc: ['适用频段：2.4GHz + 5GHz'], pic: 'wifi.png'},
          {label: '有线网络', desc: ['10/100 /1000Mbps 自适应'], pic: 'ethr1.png'},
          {label: '蓝牙', desc: ['支持蓝牙4.0及以上 支持BLE'], pic: 'blt.png'},
          {label: '定位', desc: ['内置GPS / 北斗 / Glonass','支持LBS功能','支持AGPS'], pic: 'lbs.png'},
          {label: '读卡器', desc: ['磁条卡读卡器×1、接触IC读卡器×1','非接IC读卡器×1、PSAM读卡器×1','MicroSD×1'], pic: 'read.png'},
          {label: '打印机', desc: ['内置58mm高速热敏打印机','打印速度120mm / s','支持外径40mm纸卷'], pic: 'prt.png'},
          {label: '扫码器', desc: ['支持QR Code / EAN-13 / UPC-A / UPC-E / EAN-8 / Code 128 / Code39 / Interleaved 2of5'], pic: 'scan.png'},
          {label: '二代证模块（选配）', desc: ['工作频率：13.56Mhz±7K hz','响应时间：<1s'], pic: '2id.png'},
          {label: '键盘', desc: ['1个开关机物理按键','内置安全金属密码键盘'], pic: 'keyb.png'},
          {label: '扬声器', desc: ['内置扬声器，功率2W'], pic: 'speaker.png'},
          {label: '接口', desc: ['USBType A×2、DB9×1','Micro USB×1、电源×1、RJ45×1'], pic: 'port.png'},
          {label: '适配器', desc: ['输入：AC 100~240V','输出：DC 12V/3 A'], pic: 'char.png'},
          {label: '尺寸（长×宽×高）', desc: ['285mm×385mm×65mm'], pic: 'size.png'},
        ]
      },
      spdata_en: {
        file: 'ZT8669',
        data: [
          {label: 'Processor', desc: ['Quad core Cortex-A73@2.0 Ghz','Quad core Cortex-A53@2.0 Ghz'],pic: 'cpu.png'},
          {label: 'Memory', desc: ['4GB RAM +64GB ROM','8GB RAM+256GB ROM(optional)', 'MicroSDx1'],pic: 'ram.png'},
          {label: 'OS', desc: ['Based on Android 9.0'], pic: 'sys.png'},
          {label: 'Display', desc: ['11.6”1920×1080','Multi-touch capacitive touch screen'], pic: 'disp.png'},
          {label: 'Camera', desc: ['130 Mega pixels','1280×720', '130 Mega pixels'], pic: 'face.png'},
          {label: 'Facial', desc: ['Automatic infrared fill light, autofocus Live detection', 'Optional 3D structured light module'], pic: 'face1.png'},
          {label: 'Cellular Network', desc: ['GSM / WCDMA / EVDO / TDD-LTE / FDD-LTE'], pic: 'mobi.png'},
          {label: 'WIFI', desc: ['2.4GHz +5GHz'], pic: 'wifi.png'},
          {label: 'Ethernet', desc: ['10M / 100M / 1000M bps'], pic: 'ethr1.png'},
          {label: 'Bluetooth', desc: ['Bluetooth 4.0 and above', 'BLE'], pic: 'blt.png'},
          {label: 'Location', desc: ['Built-in GPS/Beidou/Glonass','LBS','AGPS'], pic: 'lbs.png'},
          {label: 'Card Reader', desc: ['Magnetic ×1、Contact ×1','Contactless ×1、PSAMX1'], pic: 'read.png'},
          {label: 'Printer', desc: ['Built-in 58 mm thermal printer', 'Paper roll 40mm'], pic: 'prt.png'},
          {label: 'Scanner', desc: ['QR/ EAN-13/ UPC-A/ UPC-E/EAN-8 / Code 128/ Code39 / lnterleaved 2of5'], pic: 'scan.png'},

          {label: 'ID', desc: ['Frequency:13.56Mhz±7Khz'], pic: '2id.png'},
          {label: 'Keypad', desc: ['Power buttonx1','Encrypted pinpad'], pic: 'keyb.png'},
          {label: 'Speaker', desc: ['Built-in speaker,2W'], pic: 'speaker.png'},
          {label: 'Port', desc: ['USBTypeAx2/ RS232×x1/ RJ45×1'], pic: 'port.png'},
          {label: 'Adapter', desc: ['lnput: AC100-240V', 'Output: DC12V /3A'], pic: 'char.png'},
          {label: 'Dimension(LxW×H)', desc: ['285mm×385mm×65mm'], pic: 'size.png'},
        ]
      }
    }
  },
  methods: {
  
  },
  mounted () {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#zt8669 {
  background: white;
  margin-top: -.93rem;
}
#z1 {
  height: 9rem;
  background-image: url('../../assets/pic/zt8669/bg1.png');
  background-size: 100% 100%;
  overflow: hidden;
  padding-left: 4.9rem;
}
#z1_en {
  height: 9rem;
  background-image: url('../../assets/pic/zt8669/bg1_en.png');
  background-size: 100% 100%;
  overflow: hidden;
  padding-left: 4.9rem;
}
#z1 div, #z1_en div {
  margin-top: 2.22rem;
  margin-bottom: .3rem;
  font-size: .56rem;
  font-weight: bold;
  color: #FFFFFF;
  width: 6rem;
}
#z1 label, #z1_en label {
  display: inline-block;
  margin-right: .55rem;
  text-align: center;
}
#z1 img, #z1_en img {
  width: .65rem;
  height: .65rem;
  display: block;
  margin: 0 auto;
}
#z1 h5, #z1_en h5 {
  text-align: center;
  margin: .02rem 0;
  font-size: .22rem;
  font-weight: 400;
  color: #FFFFFF;
  font-size: .14rem;
}
#z2 {
  height: 1.78rem;
  background: #B3BED1 ;
  text-align: center;
}
#z2 label {
  display: inline-block;
  width: 11.63rem;
  font-size: .24rem;
  font-weight: 400;
  color: #FFFFFF;
  margin-top: .45rem;
  line-height: .48rem;
}

#z2_en {
  height: 1.78rem;
  text-align: center;
  background: #DDDFE1;
}
#z2_en img {
  /* height: .42rem; */
  margin: .69rem .12rem 0 .12rem;
}

#z3 {
  height: 9rem;
  background-image: url('../../assets/pic/zt8669/bg2.png');
  background-size: 100% 100%;
  overflow: hidden;
  padding-left: 3.49rem;
}
#z3 div {
  margin: 2.92rem 0 .2rem 0;
  font-size: .6rem;
  font-weight: bold;
  color: #4D4B49;
}
#z3 label {
  margin-left: .05rem;
  display: block;
  font-size: .24rem;
  font-weight: 400;
  color: #565959;
}
#z3 h5:nth-child(1) {
  margin: 2.44rem 0 0 0;
  font-size: .5rem;
  font-weight: bold;
  color: #666666;
}
#z3 h5:nth-child(2) {
  margin: .19rem 0 0 0;
  font-size: .36rem;
  font-weight: 400;
  color: #7E7E7F;
}

#z4 {
  height: 9rem;
  background-image: url('../../assets/pic/zt8669/bg3.png');
  background-size: 100% 100%;
  overflow: hidden;
  text-align: center;
}
#z4 div {
  margin-top: .83rem;
  margin-bottom: .19rem;
  font-size: .6rem;
  font-weight: bold;
  color: white;
}
#z4 label {
  margin-left: .01rem;
  font-size: .24rem;
  font-weight: 400;
  color: #F4F4F4;
}

#z5 {
  height: 9rem;
  background-image: url('../../assets/pic/zt8669/bg4.png');
  background-size: 100% 100%;
  overflow: hidden;
  text-align: center;
}
#z5_en {
  height: 9rem;
  background-image: url('../../assets/pic/zt8669/bg4_en.png');
  background-size: 100% 100%;
  overflow: hidden;
  text-align: center;
}
#z5 div, #z5_en div {
  margin-top: .53rem;
  margin-bottom: .17rem;
  font-size: .6rem;
  font-weight: bold;
  color: #4D4D4D;
}
#z5 label, #z5_en label {
  font-size: .24rem;
  font-weight: 400;
  color: #4D4D4D;
  /* margin-left: .05rem; */
}

#z6 {
  height: 9rem;
  background-image: url('../../assets/pic/zt8669/bg5.jpg');
  background-size: 100% 100%;
  overflow: hidden;
  text-align: center;
}
#z6_en {
  height: 9rem;
  background-image: url('../../assets/pic/zt8669/bg5_en.png');
  background-size: 100% 100%;
  overflow: hidden;
  text-align: center;
}
#z6 div, #z6_en div {
  font-size: .6rem;
  font-weight: bold;
  color: #FFFFFF;
  margin-top: .58rem;
}

</style>
